import { useLightMode } from '@/hooks/useLightMode'

import { AnimatePresence, motion } from 'framer-motion'

import { Box, HStack, Spinner } from '@hivewatch/dark'

import { getNotificationsTabTokens } from '../styles/tokens'

interface DrawerContainerIProps {
  title: string | React.ReactNode
  loading?: boolean
  children: React.ReactNode
}

export const DrawerContainer = ({
  title,
  loading = false,
  children,
}: DrawerContainerIProps) => {
  const colorScheme = useLightMode()
  const t = getNotificationsTabTokens(colorScheme)

  return (
    // framer-motion owns the height/opacity reveal; the dark Box owns the
    // rebrand surface + border so the two concerns stay separate.
    <motion.div
      animate={{ height: 'auto', opacity: 1 }}
      exit={{ height: 0, opacity: 0 }}
      initial={{ height: 0, opacity: 0 }}
      style={{ overflow: 'hidden', marginBottom: '5px' }}
    >
      <Box
        bg={t.surface}
        border='1px solid'
        borderColor={t.border}
        borderRadius='none'
        boxShadow={t.panelShadow}
        overflow='hidden'
      >
        <HStack
          borderBottom='1px solid'
          borderColor={t.border}
          justifyContent='space-between'
          px='1rem'
          py='0.75rem'
          w='full'
        >
          <Box
            color={t.textPrimary}
            display='flex'
            flex={1}
            textStyle='heading'
          >
            {title}
          </Box>
          <AnimatePresence>
            {loading && (
              <motion.div
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                initial={{ opacity: 0 }}
              >
                <Spinner borderWidth='3px' color={t.textSecondary} size='md' />
              </motion.div>
            )}
          </AnimatePresence>
        </HStack>
        <Box h='500px'>{children}</Box>
      </Box>
    </motion.div>
  )
}
